import { useCallback } from 'preact/hooks';
import useAppDispatch from '../../../hooks/useAppDispatch';
import './SearchByImageHomeItemFeature.less';
import ImagePicker from '../../input/ImagePicker';
import Button from '../../button/Button';
import { useTranslation } from '../../../hooks/useTranslation';
import useAppSelector from '../../../hooks/useAppSelector';
import { ProductSearchByImageMenuFeatureItem } from '../../../models/features/menu/ProductSearchByImageMenuFeatureItem';

const SearchByImageHomeItemFeature = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const menuFeatureItem = useAppSelector(
        state =>
            state.featureState
                .menuFeatureItem as ProductSearchByImageMenuFeatureItem
    );

    const startFeature = useCallback(
        (searchType: 'similar' | 'combinations') => {
            const { imageId, imageUrl, imageBase64 } = menuFeatureItem;
            if (!imageId || !imageUrl || !imageBase64) {
                return;
            }
            return dispatch.featureState.startFeature({
                featureType: `product-search-${searchType}-by-image`,
                imageId,
                imageUrl,
                imageBase64
            });
        },
        [menuFeatureItem]
    );

    if (!menuFeatureItem) {
        return null;
    }
    const { imageUrl, imageBase64, imageLoadingStatus } = menuFeatureItem;
    const isLoading = imageLoadingStatus === 'loading';
    const searchTypes = menuFeatureItem.searchTypes || [
        'similar',
        'combinations'
    ];

    return (
        <div className={`bri-SearchByImageHomeItemFeature`}>
            <ImagePicker
                selectedImageBase64={imageBase64}
                onChange={imageBase64 =>
                    dispatch.featureState.uploadImage({ imageBase64 })
                }
                isLoading={isLoading}
            >
                {searchTypes.includes('similar') && (
                    <Button
                        disabled={!imageUrl || isLoading}
                        variant="primary"
                        size="medium"
                        fullWidth
                        onClick={() => startFeature('similar')}
                    >
                        {t('PRODUCT_SEARCH_BY_IMAGE_SIMILAR')}
                    </Button>
                )}
                {searchTypes.includes('combinations') && (
                    <Button
                        disabled={!imageUrl || isLoading}
                        variant="primary"
                        size="medium"
                        fullWidth
                        onClick={() => startFeature('combinations')}
                    >
                        {t('PRODUCT_SEARCH_BY_IMAGE_COMBINATIONS')}
                    </Button>
                )}
            </ImagePicker>
        </div>
    );
};

export default SearchByImageHomeItemFeature;
